import { EditProfilePage } from '@/app/pages/profile/edit-profile-page';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/profile/edit')({
  validateSearch: z.object({
    verifiedEmail: z.string().optional(),
  }),
  component: EditProfilePage,
});
